import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import BeneficiarySyncConstants from '../constants/BeneficiarySyncConstants';
import BeneficiarySyncApiUtils from '../utils/BeneficiarySyncApiUtils';
import BeneficiarySyncParser from '../parsers/BeneficiarySyncParser';
import MoveMoneyStore from './MoveMoneyStore';
import { isEmpty } from 'lodash';

let _response = '';
let _serviceFail = false;
let _beneficiarySyncData = null;
let _syncFinished = false;
let _syncFailCount = 0;
let _syncSuccessCount = 0;
let _totalToSync = 0;
let _associatedAccountID = null;

class BeneficiarySyncStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  getResponse() {
    return _response;
  }

  isServiceFail() {
    return _serviceFail;
  }

  getSuccessSyncCount() {
    return _syncSuccessCount;
  }

  isSyncFinished() {
    return _syncFinished;
  }

  setBeneficiarySyncData(data, associatedAccountID) {
    _beneficiarySyncData = data;
    _totalToSync = data.length;
    _syncFailCount = 0;
    _syncSuccessCount = 0;
    _associatedAccountID = associatedAccountID;
  }

  checkAllSynced() {
    if (_syncFailCount + _syncSuccessCount === _totalToSync) {
      _syncFinished = true;
      this.emitChange();
    }
  }

  syncBeneficiary() {
    _beneficiarySyncData.forEach((benTempData) => {
      const benPayload = {
        account_number: benTempData.accountNumber,
        sort_code: benTempData.sortCode,
        display_name: benTempData.nickname,
        name: benTempData.name,
        reference: benTempData.reference,
        single_use: false,
      };
      BeneficiarySyncApiUtils.addBeneficiary(benPayload, _associatedAccountID);
    });
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;
    switch (actionType) {
      case BeneficiarySyncConstants.FETCH_BENEFICIARY_TO_SYNC:
        BeneficiarySyncApiUtils.fetchBeneficiaryToSync();
        break;
      case BeneficiarySyncConstants.FETCH_BENEFICIARY_SUCCESSS:
        const beneficiaryParser = new BeneficiarySyncParser();
        _response =
          beneficiaryParser.parseBeneficiarySyncListResponse(actionData);
        _serviceFail = false;
        _syncFinished = false;
        this.emitChange();
        break;
      case BeneficiarySyncConstants.FETCH_BENEFICIARY_FAIL:
        _response = actionData.error.message;
        if (isEmpty(_response)) _response = actionData.error.developer_message;
        _serviceFail = true;
        _syncFinished = false;
        this.emitChange();
        break;
      case BeneficiarySyncConstants.ADD_BENEFICIARY:
        this.setBeneficiarySyncData(actionData, data.action.id);
        this.syncBeneficiary();
        break;
      case BeneficiarySyncConstants.ADD_BENEFICIARY_SUCCESSS:
        const payeeDetails = {
          id: actionData.id,
          display_name: actionData.display_name,
          reference: actionData.reference,
          account: {
            id: data.action.id,
          },
          to_account: {
            name: actionData.name,
            sort_code: actionData.sort_code,
            account_number: actionData.account_number,
          },
          single_use: false,
        };
        MoveMoneyStore.updatePayeeList(payeeDetails);
        _syncSuccessCount++;
        this.checkAllSynced();
        break;
      case BeneficiarySyncConstants.ADD_BENEFICIARY_FAIL:
        _syncFailCount++;
        this.checkAllSynced();
        break;
      default: {
        break;
      }
    }
  }
}

export default new BeneficiarySyncStore();
